import SortIcon from '@mui/icons-material/Sort';
import {GridArrowDownwardIcon, GridArrowUpwardIcon} from '@mui/x-data-grid';

export const SORT_FIELDS = {status: 'status', contractNumber: 'contractNumber', companyName: 'companyName'} as const;

export const SORT_ORDERS = {asc: 'asc', desc: 'desc', none: 'none'} as const;

export const STATUS_COLOR_PRIORITY = ['#FF5E5E', '#FF9F00', '#3AC977', '#0D99FF', '#C64CFF'] as const;

export const SORT_ICONS = {
  [SORT_ORDERS.asc]: <GridArrowUpwardIcon fontSize="small" />,
  [SORT_ORDERS.desc]: <GridArrowDownwardIcon fontSize="small" />,
  [SORT_ORDERS.none]: <SortIcon fontSize="small" />,
};
